"use strict";

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.create");

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Row = void 0;

var antd_1 = require("antd");

var react_1 = __importStar(require("react"));

var styled_components_1 = require("styled-components");

var Row = function Row(props) {
  var theme = (0, react_1.useContext)(styled_components_1.ThemeContext);
  return react_1["default"].createElement(antd_1.Row, Object.assign({
    gutter: {
      xs: parseInt(theme['@size-xs'].replace('px'), 10),
      md: parseInt(theme['@size-s'].replace('px'), 10),
      lg: parseInt(theme['@size-m'].replace('px'), 10)
    }
  }, props));
};

exports.Row = Row;